import { initiateComposioAuth } from "../../features/assistant/assistantSlice";

export const handleComposioAuth = async ({
  assistant,
  assistantId,
  user,
  dispatch,
}) => {
  if (!assistant?.platform || !user) {
    throw new Error("Missing required authentication parameters");
  }

  const {
    platform: { name, uuid, iconUrl },
  } = assistant;
  const { uuid: userId } = user;

  const data = await dispatch(
    initiateComposioAuth({
      toolkit: name,
      seoName: name,
      uuid,
      userId,
      assistantId,
      iconUrl,
    }),
  ).unwrap();

  if (data?.redirectUrl) {
    window.location.href = data.redirectUrl;
  }

  return data;
};
